<template>
  <div class="Box">
    <el-drawer :title="title" :close-on-click-modal="false" :visible.sync="dialogstatusVisible" size="50%"
               :before-close="handleClose">
      <el-card>
        <el-divider content-position="left">小说审核记录</el-divider>
        <el-table
            ref="multipleTable"
            :data="StatusList"
            size="medium"
            tooltip-effect="dark"
            style="width: 100%"
            border
            :header-cell-style="{ textAlign: 'center' ,background:'#f5f7fa'}"
            :cell-style="{ textAlign: 'center' }"
        >

          <el-table-column label="小说id">
            <template slot-scope="scope">{{ scope.row.novel_id }}</template>
          </el-table-column>
          <el-table-column label="审核结果">
            <template slot-scope="scope">{{ scope.row.audit_status }}</template>
            <template slot-scope="scope">
              <el-tag type="danger" v-if="scope.row.audit_status==3">{{ scope.row.audit_status_text }}</el-tag>
              <el-tag type="success" v-if="scope.row.audit_status==2">{{ scope.row.audit_status_text }}</el-tag>
              <el-tag type="info" v-if="scope.row.audit_status==0">{{ scope.row.audit_status_text }}</el-tag>
              <el-tag type="warning" v-if="scope.row.audit_status==1">{{ scope.row.audit_status_text }}</el-tag>
            </template>

          </el-table-column>
          <el-table-column label="审核详情">
            <template slot-scope="scope">{{ scope.row.audit_msg }}</template>
          </el-table-column>
          <el-table-column label="审核时间">
            <template slot-scope="scope">{{ scope.row.created_at }}</template>
          </el-table-column>
          <!-- <el-table-column label="版本">
            <template slot-scope="scope">{{ scope.row.version }}</template>
          </el-table-column> -->
          <el-table-column label="能力">
            <template slot-scope="scope">{{ scope.row.scope_list }}</template>
          </el-table-column>
        </el-table>

        <el-divider content-position="left">剧集审核记录</el-divider>
        <el-table
            ref="multipleTable"
            :data="MovieEpisodesAudit"
            size="medium"
            tooltip-effect="dark"
            style="width: 100%"
            border
            :header-cell-style="{ textAlign: 'center' ,background:'#f5f7fa'}"
            :cell-style="{ textAlign: 'center' }"
        >

          <el-table-column label="小说id">
            <template slot-scope="scope">{{ scope.row.novel_id }}</template>
          </el-table-column>
          <el-table-column label="章节id">
            <template slot-scope="scope">{{ scope.row.chapter_id }}</template>
          </el-table-column>
          <el-table-column label="章节">
            <template slot-scope="scope">第{{ scope.row.sequence }}章</template>
          </el-table-column>
          <el-table-column label="审核结果">
            <template slot-scope="scope">{{ scope.row.audit_status }}</template>
            <template slot-scope="scope">
              <el-tag type="danger" v-if="scope.row.audit_status==3">{{ scope.row.audit_status_text }}</el-tag>
              <el-tag type="success" v-if="scope.row.audit_status==2">{{ scope.row.audit_status_text }}</el-tag>
              <el-tag type="info" v-if="scope.row.audit_status==0">{{ scope.row.audit_status_text }}</el-tag>
              <el-tag type="warning" v-if="scope.row.audit_status==1">{{ scope.row.audit_status_text }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="审核详情">
            <template slot-scope="scope">{{ scope.row.audit_msg }}</template>
          </el-table-column>
          <!-- <el-table-column label="版本">
            <template slot-scope="scope">{{ scope.row.version }}</template>
          </el-table-column> -->
        </el-table>
      </el-card>
    </el-drawer>
  </div>
</template>

<script>
import {ByteBanceAPI} from '@/api/Works/ByteBance';
import {processErrors} from "@/utils/errorHandler";

export default {
  props: ['dialogstatusVisible', 'statusId', "statusName"],
  components: {},
  data() {
    return {
      title: "",
      StatusList: [],
      MovieEpisodesAudit: []
    };
  },
  methods: {
    handleClose() {
      this.$emit('StatusNone');
    }


  },
  created() {
  },
  mounted() {
    this.title = this.statusName
    let api = ByteBanceAPI()
    let params = {
      novel_id: this.statusId
    }
    api.getResults(params).then((res) => {
      if (res.code == 0) {
        this.StatusList = res.data.novel_audit;
        this.MovieEpisodesAudit = res.data.novel_chapters_audit;
      } else {
        processErrors(res);
      }
    });
  },
};
</script>
  